class AdProperties {

    constructor($rootScope, $compile, $timeout, $builderService) {

    	var _self = this;
        
        this.$rootScope = $rootScope;
        this.$compile = $compile;
        this.$timeout = $timeout;
        this.$builderService = $builderService;

        this._sizes = [
        
            { label: "Custom", id: "CUSTOM", w: null, h: null },
            { label: "Skyscraper 120x600", id: "Skyscraper120x600", w: 120, h: 600 },
            { label: "Super Skyscraper 160x600", id: "SuperSkyscraper160x600", w: 160, h: 600 },
            { label: "Medium Rectangle 300x250", id: "MediumRectangle300x250", w: 300, h: 250 },
            { label: "Half Page 300x600", id: "HalfPage300x600", w: 300, h: 600 },
            { label: "Leaderboard 728x90", id: "Leaderboard728x90", w: 728, h: 90 },
            { label: "Billboard 970x250", id: "Billboard970x250", w: 970, h: 250 },
            { label: "Mobile Banner 300x50", id: "MobileBanner300x50", w: 300, h: 50 },
            { label: "Mobile Wide Banner 320x50", id: "MobileWideBanner320x50", w: 320, h: 50 }
            
        ];

        this._actions = [
            { id: "opencanvas", label: "Open Canvas" },
            { id: "restartcanvas", label: "Restart Canvas" },
            { id: "playtimeline", label: "Play Timeline" },
            { id: "restarttimeline", label: "Restart Timeline" },
            { id: "playvideo", label: "Play Video" },
            { id: "pausevideo", label: "Pause Video" },
            { id: "togglevideo", label: "Toggle Video" },
            { id: "toggleaudio", label: "Toggle Audio" },
            { id: "mutevideo", label: "Mute Video" },
            { id: "unmutevideo", label: "Unmute Video" },
            { id: "restartvideo", label: "Restart Video" },
            { id: "rewindvideo", label: "Rewind Video" },
            { id: "opensubcanvas", label: "Open Subcanvas" },
            { id: "pauseanimations", label: "Pause Animations" },
            { id: "resumeanimations", label: "Resume Animations" },
            { id: "fadein", label: "Fade In" },
            { id: "fadeout", label: "Fade Out" },
            { id: "custom", label: "Custom" },
            { id: "null", label: "Do Nothing" }
        ];

        this._skipProperties = {
            id: true,
            _id: true,
            $$hashKey: true,
            icon: true,
            name: true,
            subType: true,
            behaviours: true,
            contentType: true,
            contentLength: true,
            contentDisposition: true,
            maintainAspectRatio: true,
            templateVars: true,
            contentEditable: true,
            visibleInDesigner: true,
            encodings: true,
            fonts: true,
            assets: true,
            useFeed: true,
            canvases: true,
            customJS: true,
            adunitKey: true,
            createdBy: true,
            createdDate: true,
            description: true,
            deviceroots: true,
            lastModified: true,
            fallbackMacro: true,
            noscriptMacro: true,
            lastModifiedBy: true,
            impressionMacro: true,
            tagScriptVersion: true,
            fallbackOutlinkMacro: true,
            noscriptOutlinkMacro: true,
            supportSafariWindows: true,
            bootstrapScriptVersion: true,
            minSupportedInternetExplorer: true,
            layers: true,
            devices: true,
            keyframes: true,
            timelines: true,
            animations: true,
            engagementMacro: true,
            keyframeMarkers: true,
            selected: true,
            fallbackImage: true,
            colourSwatches: true,
            scope: true,
            assetId: true,
        };

        this.contentTypeHandlers = {
            "x-reflow/adunit": this.setupForAdunit,
            "x-reflow/canvas": this.setupForCanvas,
            "x-reflow/layer": this.setupForLayer,
        };

        return {
            restrict: 'E',
            templateUrl: 'builder/ad-properties.html',
            replace: false,
            scope: {
                'entity': '=',
                'campaign': '=',
                'time': '=',
                'adunit': '=',
                'feeds': '='
            },
            link: ($scope, $el, $attr) => {
                
                $scope.actions = _self._actions;                
                $scope.fonts = $.extend({}, $builderService.getFonts());
                $scope.lastContentType = "";
                
                delete window.REFLOW_DYNAMIC;

                //$scope.selectTemplate = (t) => _self.selectTemplate.call(_self, t);
                $('> .property-page-header', $el).draggable({
                    appendTo: $el.parent(),
                    helper: 'clone',
                    drag: (ev, ui) => {

                        let thisOffset = $el.offset();
                        let thisPos = $el.position();
                        //console.log(ui.offset.top, ui.offset.left, thisOffset.top, thisOffset.left, builderOffset.top, builderOffset.left);
                        let top = (ui.offset.top - thisOffset.top + thisPos.top);
                        let left = (ui.offset.left - thisOffset.left + thisPos.left);
                        $el.css({
                            top: top,
                            left: left
                        });
                        $('> .property-page-header', $el).css({top: 0, left: 0});

                    }
                });

                $scope.$watch("entity", (newitem, olditem) => {
                    
                    if(newitem == null) {
                        return;
                    }                    
                    
                    $scope.targetCanvas = null;
                    $scope.thisCanvas = null;

                    if(olditem != null && !("undefined" == typeof newitem || "undefined" == typeof olditem)) {
                        if(newitem.contentType != olditem.contentType || newitem.id != olditem.id) {
                            $("ad-tool-window", $el).trigger("close", "behaviour");
                        }
                    }

                    $scope.dims = {
                        id: newitem.id,
                        width: newitem.width,
                        height: newitem.height,
                        looping: false
                    };


                    this.contentTypeHandlers[newitem.contentType].call(this, $scope, newitem, olditem, $el);

                    this.calculateProperties($scope);


                });

                $scope.$watch("entity.width", (newitem, olditem) => {
                    if("undefined" !== typeof newitem && newitem != $scope.dims.width) {
                        $scope.dims.width = newitem;
                    }
                });

                $scope.$watch("entity.height", (newitem, olditem) => {
                    if("undefined" !== typeof newitem && newitem != $scope.dims.height) {
                        $scope.dims.height = newitem;
                    }
                });

                $scope.$watch("entity.engagement", (newitem, olditem) => {
                    if(!!newitem && !$scope.entity.engagementMacro) {
                        $scope.entity.engagementMacro = "ENGAGEMENT";
                    }
                });

                $scope.$watch("dims", (newitem, olditem) => {
                    if("undefined" === typeof newitem || "undefined" === typeof newitem.width || "undefined" === typeof newitem.height) {
                        return;
                    }
                    else if("undefined" !== typeof olditem && newitem.id !== olditem.id) {
                        return;
                    }
                    else if(newitem.looping) {
                        $scope.dims.looping = false;
                        return;
                    }
                    $scope.entity.maintainAspectRatio = $scope.dims.maintainAspectRatio;
                    $scope.entity.width = newitem.width;
                    $scope.entity.height = newitem.height;
                    $scope.entity.maintainAspectRatio = newitem.maintainAspectRatio;

                    if(newitem.maintainAspectRatio && !olditem.maintainAspectRatio) {
                        $scope.aspectRatio = newitem.width / newitem.height;
                    }

                    if($scope.entity.contentType == "x-reflow/layer" || $scope.entity.contentType == "x-reflow/canvas") {
                        if(newitem.maintainAspectRatio) {

                            if(newitem.width !== olditem.width) {
                               newitem.height = $scope.entity.height = Math.round(newitem.width / $scope.aspectRatio);
                               $scope.dims.looping = true;
                            }
                            else if(newitem.height !== olditem.height) {
                                newitem.width = $scope.entity.width = Math.round(newitem.height * $scope.aspectRatio);
                                $scope.dims.looping = true;
                            }
                        }
                    }

                }, true);

                $scope.$watch("adunit.fonts", (newitem) => {
                    $scope.fonts = $.extend({}, $builderService.getFonts());
                    $.each(newitem, (k, v) => {
                        $scope.fonts[v.name] = "'" + v.name + "'";
                    });
                }, true);


                $scope.addTimeline = () => _self.addTimeline.call(_self, $scope);
                $scope.selectTimeline = (a) => _self.selectTimeline.call(_self, a, $scope);
                $scope.removeTimeline = (ix) => _self.removeTimeline.call(_self, ix, $scope);
                $scope.copyTimeline = (ix, $event) => _self.copyTimeline.call(_self, ix, $scope, $event);

                $scope.addBehaviour = () => _self.addBehaviour.call(_self, $scope);
                $scope.copyBehaviour = (ix, $event) => _self.copyBehaviour.call(_self, ix, $scope, $event);
                $scope.selectBehaviour = (b) => _self.selectBehaviour.call(_self, b, $scope);
                $scope.removeBehaviour = (ix) => _self.removeBehaviour.call(_self, ix, $scope);
                $scope.hideBehaviours = () => _self.hideBehaviours.call(_self);

                $scope.showFonts = () => {
                    $rootScope.$emit("show-fonts");
                };

                $scope.isVideoAsset = () => {
                    return (x) => {
                        if(!!x.assetId) {
                            let asset = $scope.adunit.assets[x.assetId];
                            return asset.contentType.startsWith("video/");
                        }
                        else {
                            return false;
                        }
                    };
                };

                $scope.isVideo = () => {
                    let asset = $scope.adunit.assets[$scope.entity.assetId];
                    return asset.contentType.startsWith("video/");
                };

                $scope.timelinesForTarget = (t) => {
                    var results = [];
                    if(!!t) {
                        $scope.adunit.canvases.forEach( (x) => {
                            if(x.id == t) {
                                results = x.timelines;
                            }
                        });
                    }
                    return results;
                };

                $scope.layersForBehaviour = (b) => {
                    var results = [];
                    if(!!b) {
                        $scope.adunit.canvases.forEach( (x) => {
                            if(x.id == b.canvas) {
                                results = x.layers;
                            }
                        });
                    }
                    return results;
                };

            }             
        };

    }

    isCanvasLocked($scope) {
        return typeof $scope.entity.locked != "undefined" && $scope.entity.locked;
    }

    setupForAdunit($scope, entity, prevEntity, $el) {
        $scope.hasCustomProps = false;
        $('.layer-custom-properties', $el).html("<div class='alert alert-warning'>No custom properties found</div>");
        $scope.lastContentType = "";
    }

    setupForCanvas($scope, entity, prevEntity, $el) {

        $scope.hasCustomProps = false;
        $('.layer-custom-properties', $el).html("<div class='alert alert-warning'>No custom properties found</div>");
        $scope.lastContentType = "";

        if(!!entity.timelines) {
            entity.timelines.forEach( t => t.selected = false );
        }

        if(prevEntity != null) {
            if(entity.size != "CUSTOM" && entity.size != prevEntity.size) {
                let size = this._sizes.find( (x) => x.id == entity.size );
                $scope.$evalAsync(() => {
                    entity.width = size.w;
                    entity.height = size.h;
                });
            }
        }

    }

    setupForLayer($scope, entity, oldentity, $el) {

        $scope.dims.maintainAspectRatio = entity.maintainAspectRatio;
        $scope.aspectRatio = entity.width / entity.height;        
        $scope.asset = $scope.adunit.assets[entity.assetId];

        $scope.customActions = [];
        $scope.adunit.canvases.forEach( c => {
            
            c.layers.forEach( l => {

                if(l.id === entity.id) {
                    $scope.thisCanvas = c;
                    if(!!l.templateVars) {
                        Object.keys(l.templateVars).forEach((key) => {
                            if(!!!entity[key]) {
                                entity[key] = l.templateVars[key];
                            }
                        });
                    }
                }

                // while we're here, pull out a list of all the custom actions for every layer - gets filtered in the actual dropdown by layer
                $.each($scope.adunit.assets[l.assetId].customActions, (ix, v) => { 
                    $scope.customActions.push(JSON.parse(JSON.stringify({ layer: l.id, action: v.action, name: v.name })));
                });


            });
        });

        entity.behaviours.forEach( x => {
            x.selected = false;
            if(!x.canvas) {
                x.canvas = $scope.thisCanvas.id;
            }
        });

        // clean up the previous property widget
        if(!!$scope.lastChildScope) {
            $scope.lastChildScope.$destroy();
            delete $scope.lastChildScope;
        }
        $('.layer-custom-properties', $el).empty();
        
        this.$timeout( () => { //need to wait for DOM to render
            
            if(!!$scope.asset) {
                let widget = this.$builderService.findWidget($scope.asset.contentType);
                if(widget !== null && !!widget.properties) {
                    // create a new one
                    $scope.lastChildScope = $scope.$new();
                    let customProps = this.$compile(widget.properties)($scope.lastChildScope);
                    $('.layer-custom-properties', $el).append(customProps);
                    $scope.hasCustomProps = true;
                    $scope.lastContentType = widget.contentType;
                }
                else {
                    $('.layer-custom-properties', $el).html("<div class='alert alert-warning'>No custom properties found</div>");
                    $scope.hasCustomProps = false;
                    $scope.lastContentType = "";
                }
            }
            else {
                $('.layer-custom-properties', $el).html("<div class='alert alert-warning'>No custom properties found</div>");
                $scope.hasCustomProps = false;
                $scope.lastContentType = "";
            }

        }, 0);

    }

    addBehaviour($scope) {
        let behaviour = {
            type: "null",
            action: "",
            target: null,
            canvas: ($scope.thisCanvas || {}).id
        };
        if(!$scope.entity.behaviours) {
            $scope.entity.behaviours = [behaviour]
        } else {
            $scope.entity.behaviours.push(behaviour);
        }
        this.selectBehaviour(behaviour, $scope);
        this.showBehaviours();
    }

    copyBehaviour(ix, $scope, $event) {
        if(!this.isCanvasLocked($scope)) {
            $event.stopPropagation();
            let copiedBehaviour = JSON.parse(JSON.stringify($scope.entity.behaviours[ix]));
            $scope.entity.behaviours.push(copiedBehaviour);
            //Select the newly copied behaviour
            $scope.selectBehaviour($scope.entity.behaviours[$scope.entity.behaviours.length-1], $scope);
            this.showBehaviours();
        }
    }

    selectBehaviour(behaviour, $scope) {
        $scope.entity.behaviours.forEach( x => x.selected = false);
        $scope.currentBehaviour = behaviour;
        $scope.currentBehaviour.selected = true;
        this.showBehaviours();
    }

    removeBehaviour(ix, $scope) {
        if(!this.isCanvasLocked($scope)) {
            $scope.entity.behaviours.splice(ix, 1);
            this.hideBehaviours();
        }
    }

    showBehaviours() {
        $(".ad-properties-behaviour").css("display", "block");
    }

    hideBehaviours() {
        $(".ad-properties-behaviour").css("display", "none");
    }

    addTimeline($scope) {
        if($scope.entity.contentType == 'x-reflow/canvas') {
            if("undefined" === typeof $scope.entity.timelines) {
                $scope.entity.timelines = [];
            }
            var ix = 1;
            $.each($scope.entity.timelines, (i, a) => {
                if(a.name.startsWith("New timeline")) {
                    ix++;
                }
            });
            let timeline = {
                id: ObjectId(),
                name: "New timeline " + ix,
                duration: 30,
                animations: [ ],
                timelines: [ ],
                keyframeMarkers: [ ]
            };
            $scope.entity.timelines.push(timeline);
            this.selectTimeline(timeline, $scope);
        }
    }

    selectTimeline(timeline, $scope) {
        $scope.entity.timelines.forEach( t => t.selected = false );
        timeline.selected = true;
        this.$rootScope.$emit("select-timeline", { canvas: $scope.entity, timeline: timeline });
    }

    removeTimeline(ix, $scope) {
        if(!this.isCanvasLocked($scope)) {
            this.$rootScope.$emit("hide-timeline", $scope.entity.timelines[ix] );
            $scope.entity.timelines.splice(ix, 1);  
        }      
    }

    copyTimeline(ix, $scope, $event) {
        if(!this.isCanvasLocked($scope)) {
            $event.stopPropagation();
            let copiedTimeline = JSON.parse(JSON.stringify($scope.entity.timelines[ix]));
            copiedTimeline.name = "Copy of " + copiedTimeline.name;
            copiedTimeline.id = ObjectId()
            $scope.entity.timelines.push(copiedTimeline);     
        }
    }

    calculateProperties($scope) {
        
        let properties = [];

        $.each($scope.entity, (k, v) => {
            if(!this._skipProperties[k] && properties.indexOf(k) === -1) {
                properties.push(k);
            }
        });


        if(properties.indexOf("display") === -1) {
            properties.push("display")
        }

        if(properties.indexOf("cssClasses") === -1) {
            properties.push("cssClasses");
        }

        if(!!$scope.asset && $scope.asset.contentType.startsWith("image")) {
            if(properties.indexOf("src") === -1) {
                properties.push("src");
            }
        }
        
        properties.sort();
        
        $scope.properties = properties;

    }


}

class AdPropertiesDraggable {
    constructor() {
        return {
            restrict: 'A',
            scope: {
            },
            link: ($scope, $el, $attr) => {

                $('.property-page-header', $el).draggable({
                    appendTo: $el.parent(),
                    helper: 'clone',
                    drag: (ev, ui) => {
                        let thisOffset = $el.offset();
                        let thisPos = $el.position();
                        let top = (ui.offset.top - thisOffset.top + thisPos.top);
                        let left = (ui.offset.left - thisOffset.left + thisPos.left);
                        $el.css({
                            top: top,
                            left: left
                        });
                        $('.property-page-header', $el).css({top: 0, left: 0});
                    }
                });

            }
        };
    }
}

var rfPropertyPageItem = angular.module('cpm').directive('rfPropertyPageItem', function() {
    return {
        restrict: 'E',
        template: '<div class="propGroupItem" ng-transclude></div>',
        transclude: true,
        scope: {
            heading: '@'
        },
        link: function($scope, element, attributes ) {
            
        }
    };
});


angular.module('cpm')
    .directive('adProperties', ["$rootScope", "$compile", "$timeout", "$builderService", ($rootScope, $compile, $timeout, $builderService) => {
        'use strict';
        return new AdProperties($rootScope, $compile, $timeout, $builderService);
    }]).directive('adPropertiesDraggable', [() => {
        'use strict';
        return new AdPropertiesDraggable();
    }]);


